import { Component, Input, OnInit, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'dum-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent {

  constructor(
    private messageService: MessageService
  ) { }


  add(message: {severity: string, summary: string, detail: string }) {
    this.messageService.add({ severity: message.severity, summary: message.summary, detail: (message.detail)});
  }

}
